<div class="website-content" style="max-width:72rem;padding:0 var(--wa-spacing-x-large) var(--wa-spacing-x-large) var(--wa-spacing-x-large);">
	<div class="wa-stack wa-gap-xl">
		<div class="wa-stack wa-gap-m content-section">
			<wa-divider class="section-divider"></wa-divider>
			<div class="wa-stack wa-gap-s">
				<div class="hero-eyebrow" waCaption="s" waFontWeight="semibold" waText>QUICK START</div>
				<h2 waHeading="l" waText>Getting Started with JWebMP</h2>
				<p waBody="m" waColorText="quiet" waText>Choose your mode. Follow the steps. Ship your app.</p>
			</div>
			<div class="wa-stack wa-gap-m">
				<p waBody="m" waText>This guide walks you through creating a JWebMP application from scratch. JWebMP supports two running modes &mdash; choose the one that fits your project:</p>
				@if (!useGradle) {
					<div>
						<div waCaption="s" waFontWeight="semibold" waText>Prerequisites</div>
						<div class="wa-cluster wa-gap-s">
							<a href="https://adoptium.net" rel="noopener noreferrer" style="text-decoration:none;" target="_blank">
								<wa-tag pill variant="brand">Java 25+</wa-tag>
							</a>
							<a href="https://maven.apache.org" rel="noopener noreferrer" style="text-decoration:none;" target="_blank">
								<wa-tag pill variant="neutral">Maven 3.9+</wa-tag>
							</a>
							<a href="https://nodejs.org" rel="noopener noreferrer" style="text-decoration:none;" target="_blank">
								<wa-tag pill variant="warning">Node.js 22+</wa-tag>
							</a>
						</div>
					</div>
				}
				@if (useGradle) {
					<div>
						<div waCaption="s" waFontWeight="semibold" waText>Prerequisites</div>
						<div class="wa-cluster wa-gap-s">
							<a href="https://adoptium.net" rel="noopener noreferrer" style="text-decoration:none;" target="_blank">
								<wa-tag pill variant="brand">Java 25+</wa-tag>
							</a>
							<a href="https://gradle.org" rel="noopener noreferrer" style="text-decoration:none;" target="_blank">
								<wa-tag pill variant="neutral">Gradle 8.6+</wa-tag>
							</a>
							<a href="https://nodejs.org" rel="noopener noreferrer" style="text-decoration:none;" target="_blank">
								<wa-tag pill variant="warning">Node.js 22+</wa-tag>
							</a>
						</div>
					</div>
				}
				<div class="wa-stack wa-gap-m">
					<wa-details summary="Angular Mode (Client-Side/MicroFront SPA)">
						<div class="wa-stack">
							<p waBody="m" waText>Include the Angular plugin and the build plugin generates a complete Angular 21 single-page application. Node.js is required at build time for the Angular CLI. The resulting SPA is static and can be served from any host or CDN &mdash; the JWebMP server is entirely optional.</p>
							<markdown [data]="mdContent_9" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
						</div>
					</wa-details>
					<wa-details summary="Hosted Mode (JWebMP + GuicedEE Backend)">
						<div class="wa-stack">
							<p waBody="m" waText>JWebMP hosts the application on a Vert.x 5 endpoint alongside your GuicedEE backend. REST APIs, WebSockets, authentication, and persistence all run on the same process. Add the Angular plugin to serve a compiled SPA from the same endpoint, or render pages server-side.</p>
							<markdown [data]="mdContent_10" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
						</div>
					</wa-details>
				</div>
			</div>
		</div>
		<div class="wa-stack wa-gap-m content-section">
			<wa-divider class="section-divider"></wa-divider>
			<div class="wa-stack wa-gap-s">
				<div class="hero-eyebrow" waCaption="s" waFontWeight="semibold" waText>BOOTSTRAP</div>
				<h2 waHeading="l" waText>Configure the Build Plugin</h2>
				<p waBody="m" waColorText="quiet" waText>Let the build plugin handle everything &mdash; or start the server manually.</p>
			</div>
			<div class="wa-stack wa-gap-m">
				<p waBody="m" waText>Angular mode uses a build plugin that generates the entire Angular project during your build. Hosted mode starts the GuicedEE runtime with a Vert.x HTTP server.</p>
				@if (!useGradle) {
					<div class="code-block-wrapper">
						<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Angular mode &mdash; Maven plugin &#40;pom.xml&#41;</div>
						<markdown [data]="mdContent_11" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
					</div>
				}
				@if (useGradle) {
					<div class="code-block-wrapper">
						<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Angular mode &mdash; Gradle plugin &#40;build.gradle.kts&#41;</div>
						<markdown [data]="mdContent_12" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
					</div>
				}
				<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>The plugin discovers your annotated classes, generates TypeScript, installs npm dependencies, and runs the Angular CLI &mdash; all in one build step.</div>
				<div class="code-block-wrapper">
					<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Hosted mode &mdash; Boot.java &#40;Vert.x server&#41;</div>
					<markdown [data]="mdContent_13" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				</div>
			</div>
		</div>
		<div class="wa-stack wa-gap-m">
			<p waBody="m" waText>The module descriptor and your first component are identical for both modes. Use the menu tree to navigate each remaining step.</p>
		</div>
	</div>
</div>